/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const PGPKeyType = {
    MasterKey: 'MASTER_KEY',
    SubKey: 'SUB_KEY',
    All: 'ALL'
} as const;

export type PGPKeyType = typeof PGPKeyType[keyof typeof PGPKeyType];



